export default "__VITE_ASSET__DokplGRF__"